<template>
  <div class="container-fluid">
    <b-overlay :show="showOverlay" rounded="sm">
      <b-col class="container text-right"> </b-col>

      <b-card class="mt-2 col-12">
        <b-tabs>
          <b-tab
            v-for="tab in tabs"
            :key="tab.title"
            :title="tab.title"
            lazy
            @click.prevent="setActiveTabName(tab.mode)"
          >
            <b-col cols="12">
              <SearchFilter
                ref="searchFilter"
                :mode="tab.mode"
                @handleSubmit="searchFilterSubmit"
              />
            </b-col>
          </b-tab>
        </b-tabs>
      </b-card>

      <b-card v-for="tab in activeTab" :id="tab" :key="tab">
        <commonTable
          ref="tableCommon"
          :routeName="$route.name"
          :tableHeader="tableHeader"
          :searchMode="tab"
          @handleGroup="getManageGroup"
          @handleOverlay="setOverlay"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BOverlay,
} from "bootstrap-vue";

import commonTable2 from "../../table/vue-good-table/commonTableModal.vue";
import SearchFilter from "./components/SearchFilter.vue";

import commonTable from "@/views/Complaint/components/vueGoodTable/commonTable.vue";
/// ปรับมาดึง header ของตัวเองเพราะจะแสดงผลไม่เหมือนกัน
import commonTableHeader from "./components/commonTableHeader.js";

import * as officerStore from "@/store/api/officer/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import appsettings from "@/store/app-settings";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    commonTable,
    commonTable2,
    SearchFilter,
    BOverlay,
  },
  data() {
    return {
      tabs: [
        { title: "รายการเรื่องร้องทุกข์", mode: "Bangkok" },
        { title: "ประวัติดำเนินการ", mode: "UserBangkokHistory" },
      ],
      activeTab: ["Bangkok"],
      modalName: "my-modal",
      notificationComplaints: [],
      tableHeader: commonTableHeader,
      showOverlay: false,
    };
  },
  methods: {
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    getComplaintNotification() {
      const _this = this;
      officerStore
        .getComplaintForNoti(userData.departmentId(), userData.userId())
        .then((response) => {
          console.log("data", response.data.data);
          if (response.data.data.totalresult > 0) {
            // show data
            _this.notificationComplaints = response.data.data.listForNewcase;

            _this.$refs.ModalNotification.$refs["modal-notification"].show();
          }
          //_this.$refs.ModalNotification.$refs["modal-notification"].show();
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    setActiveTabName(name) {
      this.activeTab = [];
      this.activeTab.push(name);
    },
    getManageGroup(id) {
      if (this.activeTab[0] == "UserBangkokHistory") {
        const routeData = this.$router.resolve({
          name: "BangkokOfficerHistory",
          query: { id },
        });
        window.open(routeData.href, "_blank");
      } else {
        const routeData = this.$router.resolve({
          name: "BangkokOfficerManage",
          query: { id },
        });
        window.open(routeData.href, "_blank");
      }
    },
    searchFilterSubmit(params) {
      // if (this.$route.query.id == null) {
      //   params.userActive = userData.userId();
      // } else {
      //   params.userActive = this.$route.query.id;
      // }

      params.departmentId = appsettings.provinceDepartmentId;

      this.$refs.tableCommon[0].onSearchSubmit(params);
    },
    onBtnClosePopup() {
      if (this.$modals.isActive(this.modalName) === true)
        this.$modals.hide(this.modalName);
    },
    onBtnReceive() {
      if (this.$modals.isActive(this.modalName) === true)
        this.$modals.hide(this.modalName);
    },
    onBtnAddClicked() {
      window.open(
        this.$router.resolve({
          name: "servicecentercomplaint",
          query: { parentComponent: "Officer" },
        }).href,
        "_self",
      );
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
/* ตั้งสี primary แค่ที่เดียว */
:root {
  --primary: #00904b !important; /* <<< เปลี่ยนสีตรงนี้ครั้งเดียว */
  --primary-dark: #017b40 !important;
}

/* Override สี primary ของ Bootstrap 4 ทั้งหน้า */
/* TEXT */
.text-primary {
  color: var(--primary) !important;
}

/* BACKGROUND */
.bg-primary {
  background-color: var(--primary) !important;
}

/* BORDER */
.border-primary {
  border-color: var(--primary) !important;
}

/* BUTTON - PRIMARY */
.btn-primary {
  color: #fff !important;
  background-color: var(--primary) !important;
  border-color: var(--primary-dark) !important;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.show > .btn-primary.dropdown-toggle {
  background-color: var(--primary-dark) !important;
  border-color: var(--primary-dark) !important;
}

.btn-primary.disabled,
.btn-primary:disabled {
  background-color: var(--primary-light) !important;
  border-color: var(--primary-light) !important;
}

/* BUTTON - OUTLINE PRIMARY */
.btn-outline-primary {
  color: var(--primary) !important;
  border-color: var(--primary) !important;
}

.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:active,
.btn-outline-primary.active,
.show > .btn-outline-primary.dropdown-toggle {
  color: #fff !important;
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
  color: var(--primary-light) !important;
  border-color: var(--primary-light) !important;
}

/* BADGE */
.badge-primary {
  background-color: var(--primary) !important;
  color: #fff !important;
}

/* ALERT */
.alert-primary {
  background-color: var(--primary) !important;
  border-color: var(--primary-dark) !important;
  color: #fff !important;
}

/* LIST GROUP */
.list-group-item-primary {
  background-color: var(--primary) !important;
  color: #fff !important;
}

/* TABLE */
.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: var(--primary) !important;
  color: #fff !important;
}

/* PROGRESS BAR */
.progress-bar.bg-primary,
.progress-bar-primary {
  background-color: var(--primary) !important;
}

/* PAGINATION */
.page-item.active .page-link {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}

.page-link:hover {
  color: var(--primary) !important;
}

/* CARD */
.card.border-primary {
  border-color: var(--primary) !important;
}

.card-header.bg-primary,
.card-header.border-primary {
  background-color: var(--primary) !important;
  border-color: var(--primary-dark) !important;
}

/* NAVBAR (text-primary, bg-primary, border-primary already cover most) */
.navbar-light .navbar-nav .nav-link.text-primary:hover {
  color: var(--primary-dark) !important;
}

.dark-layout .nav-tabs .nav-item .nav-link.active,
.dark-layout .nav-pills .nav-item .nav-link.active,
.dark-layout .nav-tabs.nav-justified .nav-item .nav-link.active {
  color: var(--primary-dark);
}

/* LINKS */
a.text-primary:hover,
a.text-primary:focus {
  color: var(--primary-dark) !important;
}

[dir="ltr"] .main-menu.menu-light .navigation > li ul .active {
  background: linear-gradient(118deg, var(--primary), rgba(0, 144, 75, 0.7));
}

[dir] .main-menu.menu-light .navigation > li ul .active {
  box-shadow: 0 0 10px 1px rgba(0, 144, 75, 0.7);
  border-radius: 4px;
}

.main-menu .navbar-header .navbar-brand .brand-text {
  color: var(--primary);
}

.dark-layout .main-menu .collapse-toggle-icon {
  color: var(--primary) !important;
}

a {
  color: var(--primary);
}

.nav-tabs .nav-link.active {
  color: var(--primary);
}

[dir="ltr"] .nav-tabs .nav-link:after {
  left: 0;
  background: linear-gradient(
    30deg,
    var(--primary),
    rgba(0, 144, 75, 0.5)
  ) !important;
}

.dropdown-item:hover,
.dropdown-item:focus {
  color: var(--primary);
}

[dir] .dropdown-item:hover,
[dir] .dropdown-item:focus {
  background-color: rgba(0, 144, 75, 0.12);
}

[dir] .dropdown-item.active,
[dir] .dropdown-item:active {
  background-color: var(--primary);
}

[dir] .btn-primary:hover:not(.disabled):not(:disabled) {
  box-shadow: 0 8px 25px -8px var(--primary);
}

.badge.badge-light-primary {
  color: var(--primary) !important;
}

.brand-logo img {
  content: url("/250px-bangkok.png");
  max-height: 62px;
}

[dir] .custom-control-input:checked ~ .custom-control-label::before {
  border-color: var(--primary);
  background-color: var(--primary);
}

[dir]
  .custom-checkbox
  .custom-control-input:checked
  ~ .custom-control-label::before,
[dir]
  .custom-radio
  .custom-control-input:checked
  ~ .custom-control-label::before {
  box-shadow: 0 2px 4px 0 rgba(0, 144, 75, 0.4) !important;
}

[dir]
  .custom-checkbox
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: rgba(0, 144, 75, 0.65);
}

[dir]
  .custom-control-input:not(:disabled):active
  ~ .custom-control-label:before {
  background-color: var(--primary);
  border-color: var(--primary);
}

.vs__dropdown-option--selected.vs__dropdown-option--highlight {
  color: #fff !important;
  background-color: var(--primary) !important;
}

#app [dir] .vs--open .vs__dropdown-toggle {
  border-color: var(--primary);
  border-bottom-color: var(--primary);
  box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
}

#app [dir] .vs__dropdown-option--highlight {
  background-color: rgba(0, 144, 75, 0.12) !important;
}

#app [dir] .vs__dropdown-option--selected {
  background-color: var(--primary) !important;
}

#app [dir] .vs__dropdown-option--selected.vs__dropdown-option--highlight {
  background-color: var(--primary) !important;
}

#app .vs__dropdown-option--highlight {
  color: var(--primary) !important;
}

#app .vs__dropdown-option--selected {
  background-color: var(--primary) !important;
  color: #fff !important;
  position: relative;
}

a:hover {
  color: var(--primary-dark);
  text-decoration: none;
}

.dark-layout a:hover {
  color: var(--primary-dark);
}

[dir] .main-menu.menu-light .navigation > li.active > a {
  box-shadow: 0 0 10px 1px rgba(0, 144, 75, 0.7);
  border-radius: 4px;
}
</style>
